/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, ListGroup, Table } from 'react-bootstrap';
import './style.scss';
import { compare } from '../../utils';
import Loading from '../loading';

const MBTIResult = ({ score, selectedSignature, signatureTemplate = {} }) => {
  const itemKeysLine1 = ['I', 'E', 'N', 'S'];
  const itemKeysLine2 = ['T', 'F', 'P', 'J'];
  const [signature, setSignature] = useState([]);
  const [itemScore, setItemScore] = useState({});
  const [loading, setLoading] = useState(true);

  /**
   * Get score for each item
   */
  useEffect(() => {
    const itemScoreFromProps = Object.keys(score).reduce((map, key) => {
      // eslint-disable-next-line no-param-reassign
      map[key] = score[key].reduce((total, a) => total + a.answer, 0);
      return map;
    }, {});
    setItemScore(itemScoreFromProps);
  }, [score]);

  /**
   * Get signature from itemScore
   */
  useEffect(() => {
    const first = compare(itemScore, 'I', 'E');
    const second = compare(itemScore, 'N', 'S');
    const third = compare(itemScore, 'T', 'F');
    const fourth = compare(itemScore, 'P', 'J');
    setSignature([first, second, third, fourth]);
  }, [itemScore]);

  useEffect(() => {
    if (selectedSignature) {
      selectedSignature(signature.join(''));
    }
  }, [signature]);

  useEffect(() => {
    console.log(signatureTemplate);
    if (signatureTemplate) {
      setLoading(false);
    }
  }, [signatureTemplate]);

  const renderItems = itemKey => (
    <td key={itemKey}>
      <p><Badge variant="danger">{`${itemKey} items`}</Badge></p>
      {score[itemKey].map(item => <p key={item.id}>{item.question}</p>)}
      <p>
        <b>
          {`Total ${itemKey}: `}
          <Badge variant="success">{itemScore[itemKey]}</Badge>
        </b>
      </p>
    </td>
  );

  return (
    <>
      {loading ? <Loading /> : (
        <>
          <Table responsive striped bordered hover className="mbti-result">
            <tbody>
              <tr>
                <td colSpan="2" className="text-center"><b>DIMENSION 1</b></td>
                <td colSpan="2" className="text-center"><b>DIMENSION 2</b></td>
              </tr>
              <tr>
                {itemKeysLine1.map(itemKey => renderItems(itemKey))}
              </tr>
              <tr>
                <td colSpan="2" className="text-center"><b>DIMENSION 3</b></td>
                <td colSpan="2" className="text-center"><b>DIMENSION 4</b></td>
              </tr>
              <tr>
                {itemKeysLine2.map(itemKey => renderItems(itemKey))}
              </tr>
            </tbody>
          </Table>

          <div className="jumbotron row">
            <div className="col-lg-6">
              <h3 className="text-center">YOUR PERSONALITY SIGNATURE IS:</h3>
              <ListGroup horizontal className="result_dimension">
                {signature.map(s => <ListGroup.Item key={s} variant="danger">{s}</ListGroup.Item>)}
              </ListGroup>
            </div>
            <div className="col-lg-6">
              <div className="text-center">
                <h3><Badge variant="info">{signatureTemplate?.Title}</Badge></h3>
                <p>{signatureTemplate?.Description}</p>
              </div>
            </div>

          </div>
        </>
      )}

    </>
  );
};

MBTIResult.propTypes = {
  score: PropTypes.shape({
    I: PropTypes.shape([]),
    E: PropTypes.shape([]),
    N: PropTypes.shape([]),
    S: PropTypes.shape([]),
    T: PropTypes.shape([]),
    F: PropTypes.shape([]),
    P: PropTypes.shape([]),
    J: PropTypes.shape([])
  }).isRequired,
  selectedSignature: PropTypes.func,
  signatureTemplate: PropTypes.shape({
    Description: PropTypes.string,
    Title: PropTypes.string,
    Signature: PropTypes.string
  })
};

export default MBTIResult;
